import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/manrope';
import '@fontsource-variable/noto-sans-arabic';
import '@fontsource-variable/noto-sans-devanagari';
import './styles/tokens.css';
import './index.css';
import './styles/chat.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { applyPinnedTheme } from './theme';

// The widget pins a theme (/embed?theme=…); the full page follows the device. Applied before the first paint.
applyPinnedTheme();

const queryClient = new QueryClient({
   defaultOptions: {
      queries: {
         retry: 1,
         refetchOnWindowFocus: false
      }
   }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
   <React.StrictMode>
      <QueryClientProvider client={queryClient}>
         <BrowserRouter>
            <App />
         </BrowserRouter>
      </QueryClientProvider>
   </React.StrictMode>
);
